import React from 'react'
import { Link } from 'react-router-dom';
import {TabPane} from "reactstrap";

const BulkSuccessfully = () => {
  return (
    <>
      <TabPane id="steparrow-new-tab2" tabId={9}>
        <div className="text-center" style={{ marginTop: '200px' }}>
          <div className="avatar-md mt-4 mx-auto">
            <div className="avatar-title bg-light text-success display-4 rounded-circle mt-4">
              <i className="ri-checkbox-circle-fill"></i>
            </div>
          </div>
          <h5 className="mt-4">Well Done!</h5>
          <p className="text-muted mt-4">You have Successfully Completed the Steps</p>
          <Link className="btn-soft-danger btn-border btn btn-danger" to="/">
            Home
          </Link>
        </div>
        <div className="d-flex align-items-start gap-3 mt-4"></div>
      </TabPane>
    </>
  )
}

export default BulkSuccessfully
